//import axios from "./axios";
import http from "src/services/httpService";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  /* TODO :> 
      1- SAVE TOKEN expiredate in local storage with access token 
      2- validate that date
      3- show relogin popup or use refresh token
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
  */
  return true;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//   }, timeLeft);
// };

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem(http.tokenKey, accessToken);
    http.setAccessToken();
    //axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    //TODO >> CHECK THE FOLLOWING CODE
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem(http.tokenKey);
    http.deleteAccessToken();
    //delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
